import Vue from 'vue'
import Vuex from 'vuex'
// import $url from '@/assets/config/address-config.js'
import {instance as $http} from '@/assets/config/axios-config.js';
Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        userInfo:{},    // 登录的个人信息
        product:[],
    },

    getters:{
        userInfo: state =>{
            let ecsEmployee = state.userInfo.ecsEmployee;
            return ecsEmployee
            ?{
                codes:state.userInfo.codes,
                ...ecsEmployee,
                identityName:state.userInfo.identityName,
            }
            :{}
        },
        product: state=>{
            return state.product || [];
        },
        userCodes(state){
            return  state.userInfo.codes || [];
        },
    },
        
    mutations: {
        // 变更userInfo状态
        changeUserInfo (state,obj) {
            state.userInfo = obj;
        },
        changeproduct(state,obj) {
            state.product = obj;
        },
    },
    actions: {
        //获取产品 KEY
        product({commit,state}){

                let url=`/api/supplier/get/product/list`;
                return $http.get(url)
                .then(res => {
                    var info = res.res_data || {};
                    if(res.code == 800||res.code ==900){   //session过期
                        return Promise.reject({})
                    }
                    commit('changeproduct',info);
                    // console.log(`用户信息：拉取`);
                    return Promise.resolve( JSON.parse(JSON.stringify(info)) )

                })
                .catch(err=>{
                    Promise.reject(err)
                })
        },
        // 存产品 key
        getproduct({commit,state}){
            if(state.product.length<=0){
                let url=`/api/supplier/get/product/list`;
                return $http.get(url)
                .then(res => {
                    var info = res.res_data || {};
                    if(res.code == 800||res.code ==900){   //session过期
                        return Promise.reject({})
                    }
                    commit('changeproduct',info);
                    // console.log(`用户信息：拉取`);
                    return Promise.resolve( JSON.parse(JSON.stringify(info)) )

                })
                .catch(err=>{
                    return Promise.reject(err)
                })
                
            }
            return Promise.resolve( JSON.parse(JSON.stringify(state.product)) )
        },
        // 拉取用户数据
        getUserInfo ({ commit,state },flag = false) {

            if(flag || state.userInfo && state.userInfo.ecsEmployee == undefined){
                return $http.get("/api/supplier/user/info/get")
                .then(res => {
                    var info = res.res_data || {};
                    if(res.code == 800){   //session过期
                        return Promise.resolve({})
                    }

                    commit('changeUserInfo',info);
                    // console.log(`用户信息：拉取`);
                    return Promise.resolve( JSON.parse(JSON.stringify(info)) )

                });
            }
            
            
            // console.log(`用户信息：缓存`);
            return Promise.resolve( JSON.parse(JSON.stringify(state.userInfo)) )
        },

    }

})
